export default {
  develop: 177317386199054,
  staging: 177317386199054,
  production: 177317386199054,
};
